import { render, staticRenderFns } from "./CustomRadioBorder.vue?vue&type=template&id=326dfe8e&scoped=true"
import script from "./CustomRadioBorder.vue?vue&type=script&lang=js"
export * from "./CustomRadioBorder.vue?vue&type=script&lang=js"
import style0 from "./CustomRadioBorder.vue?vue&type=style&index=0&id=326dfe8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326dfe8e",
  null
  
)

export default component.exports